export async function getCableConsumer() {
  const { consumer } = await import(/* webpackChunkName: "cable" */ 'chunks/cable')
  return consumer
}

export async function subscribeTo(channelName, mixin) {
  const consumer = await getCableConsumer()
  return consumer.subscriptions.create(channelName, mixin)
}
